module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chat-orange-90ddb1b830b045883b159f806a1b9797.svg";